import React from 'react'

const Page500 = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" id="main">
            <h1 className="mr-3 pr-3 align-top border-right inline-block align-content-center">500</h1>
            <div className="inline-block align-middle">
                <h2 className="font-weight-normal lead" id="desc">The page you are looking for is temporarily unavailable.</h2>
            </div>
        </div>
    )
}

export default Page500